import React, { ReactElement, memo, FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SkeletonImage from '../SkeletonHelpers/SkeletonImage'
import SkeletonTexts from '../SkeletonHelpers/SkeletonTexts'
import { TestID } from '../../utils/PropTypesDefinitions'

const ListTeaserSkeleton: FunctionComponent<TestID> = ({ testID }): ReactElement => {
    return (
        <Grid noExpand horizontal testID={testID} backgroundColor="pearl">
            <SkeletonImage height={94} width={94} />
            <SkeletonTexts marginLeft={5} />
        </Grid>
    )
}

export default memo(ListTeaserSkeleton)
